<template>
    <div class="dropdown" v-if="logedin">
        <a href="#" role="button" id="mein_konto" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :class="{ selected: selected }">Mein konto</a>
        <div class="dropdown-menu" aria-labelledby="mein_konto">
            <a class="dropdown-item" href="/gebotsliste">Gebotsliste</a>
            <a class="dropdown-item" href="/beobachtungsliste">Beobachtungsliste</a>
            <a class="dropdown-item" href="/zuschlagliste">Zuschlagliste</a>
            <a class="dropdown-item" href="/profile">Meine Daten</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: [Boolean],
                required: true,
                default: false
            },

            selected: {
                type: [Boolean],
                required: false,
                default: false
            }
        },

        data () { 
            return {
                logedin: false
            }
        },

        created() {
            this.logedin = this.user;
            App.event.listen('login.success', (response) => {
                this.logedin = true;
            });
        }
    }
</script>
